<div class="row h-100" cdkDropListGroup>
    <div class="col-md-6 container-flex">
        <app-employee-list
            class="container-flex"
            [updating]="updating"
            (activeChanged)="employeeInfoChanged()"
            (undraggableStateChanged)="droppedTask($event)"
        ></app-employee-list>
        <app-employee-unassigned-tasks
            class="container-flex"
            [disableDrag]="editing"
        >
        </app-employee-unassigned-tasks>
    </div>
    <div class="col-md-6 container-flex">
        <app-employee-info
            class="container-flex"
            [updating]="updating"
            [disableDrag]="editing"
            (changed)="employeeInfoChanged()"
            (undraggableStateChanged)="droppedTask($event)"
        ></app-employee-info>
    </div>
</div>
